// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LanguagesDialog_wrapper_2W8lw","language":"LanguagesDialog_language_Q65IS","error":"LanguagesDialog_error_zZskG"};